<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :disabled="!!id"
                    :repository="repositories.obito.cidadao"
                    :search-fields="fields.cidadao"
                    :text-field="(item) =>  item.cns ? `${this.formatCns(item.cns)} - ${item.nome}` : item.nome"
                    :validations="validations.cidadao"
                    label="Cidadão"
                    v-model="model.cidadao"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-date-picker
                    :max-date="additionals.dataAtual"
                    :validations="validations.obitoEm"
                    label="Data do óbito"
                    v-model="model.obitoEm"
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-time-picker
                    :validations="validations.horaObito"
                    label="Hora de óbito"
                    v-model="model.horaObito" 
                />
            </rkm-col>

            <rkm-col cols="2">
                <rkm-form-input
                    :validations="validations.declaracao"
                    label="Declaração"
                    number
                    v-model="model.declaracao"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input
                    :validations="validations.causa"
                    label="Causa"
                    v-model="model.causa"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :repository="repositories.obito.cid"
                    :search-fields="fields.cid"
                    :text-field="(item) => item.nome ? `${item.codigo} - ${item.nome}` : null"
                    label="CID"
                    v-model="model.cid"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :repository="repositories.obito.usuario"
                    :search-fields="fields.usuario"
                    :text-field="(item) => item.nome ? item.cns ? `${this.formatCns(item.cns)} - ${item.nome}` : item.nome : null"
                    label="Profissional"
                    v-model="model.usuario"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, formats, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                cidadao: {required: true},
                obitoEm: {required: true},
                horaObito: {required: true},                
                declaracao: {min: 1, max: 13},
                causa: {min: 1, max: 255},
            }
        },
    },
    created() {
        this.repositories = {
            obito: this.getConectaSusRepository('cadastro.obito'),
        }
    },
    data: () => ({
        additionals: null,
        fields: {
            cidadao: [
                {key: 'cadastroCidadao.nome', searchable: true},
                {key: 'cadastroCidadao.cns', searchable: true},
            ],
            cid: [
                {key: 'cid.codigo', searchable: true},
                {key: 'cid.nome', searchable: true},
            ],
            usuario: [
                {key: 'cadastroCidadao.nome', searchable: true},
                {key: 'cadastroCidadao.cns', searchable: true},
            ],
        },
        model: null,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            if (this.id) {
                this.edit()
            } else {
                this.create()
            }
        },
        create() {
            this.setLoading()

            this.repositories.obito.create()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {

            const request = {
                cidadaoId: this.model.cidadao.id,
                cidId: this.model.cid ? this.model.cid.id : null,
                usuarioId: this.model.usuario ? this.model.usuario.id : null,
                obitoEm: this.others.moment(this.model.obitoEm)
                    .format('YYYY-MM-DD') + ' ' +
                    this.others.moment(this.model.horaObito, ['HH:mm', 'HH:mm:ss']).format('HH:mm:ss'),
                declaracao: this.model.declaracao,
                causa: this.model.causa,
            }

            this.setLoading()

            this.repositories.obito.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.$emit('saved', response)
                    this.showSaveNotification()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        edit() {

            this.setLoading()

            this.repositories.obito.edit(this.id)
                .then(response => {

                    this.additionals = Object.assign(response.data.additionals)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => {
                    this.unsetLoading()
                })
        },
        update() {

            const request = {
                cidadaoId: this.model.cidadao.id,
                cidId: this.model.cid ? this.model.cid.id : null,
                usuarioId: this.model.usuario ? this.model.usuario.id : null,
                obitoEm: this.others.moment(this.model.obitoEm)
                    .format('YYYY-MM-DD') + ' ' +
                    this.others.moment(this.model.horaObito, ['HH:mm', 'HH:mm:ss']).format('HH:mm:ss'),
                declaracao: this.model.declaracao,
                causa: this.model.causa,
            }

            this.setLoading()

            this.repositories.obito.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.$emit('saved', response)
                    this.showSaveNotification()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.id) {
                        this.update()
                    } else {
                        this.store()
                    }
                })
        },
    },
    mixins: [error, formats, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>